import { Action, createFeatureSelector, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import * as AdvisorActions from './advisor.actions';
import { Advisor } from '../../customer-admin.model';

export const advisorFeatureKey = 'Advisor';

export interface State extends EntityState<Advisor> {
    // additional entities state properties
}

export const adapter: EntityAdapter<any> = createEntityAdapter<Advisor>({
    selectId: (model: Advisor) => `${model.AdvisorID}`
});

export const initialState: State = adapter.getInitialState({
    // additional entity state properties
});

export const AdvisorReducer = createReducer(
    initialState,
    on(AdvisorActions.addAdvisor, (state, action) =>
        adapter.addOne(action.Advisor, state)
    ),
    on(AdvisorActions.upsertAdvisor, (state, action) =>
        adapter.upsertOne(action.Advisor, state)
    ),
    on(AdvisorActions.addAdvisors, (state, action) =>
        adapter.addMany(action.Advisors, state)
    ),
    on(AdvisorActions.upsertAdvisors, (state, action) =>
        adapter.upsertMany(action.Advisors, state)
    ),
    on(AdvisorActions.updateAdvisor, (state, action) =>
        adapter.updateOne(action.Advisor, state)
    ),
    on(AdvisorActions.updateAdvisors, (state, action) =>
        adapter.updateMany(action.Advisors, state)
    ),
    on(AdvisorActions.deleteAdvisor, (state, action) =>
        adapter.removeOne(action.id, state)
    ),
    on(AdvisorActions.deleteAdvisors, (state, action) =>
        adapter.removeMany(action.ids, state)
    ),
    on(AdvisorActions.loadAdvisors, (state, action) =>
        adapter.setAll(action.Advisors, state)
    ),
    on(AdvisorActions.clearAdvisors, state =>
        adapter.removeAll(state)
    )
);

export function reducer(state: State | undefined, action: Action) {
    return AdvisorReducer(state, action);
}

export const selectAdvisorState = createFeatureSelector<State>(
    advisorFeatureKey
);

export const { selectIds, selectEntities, selectAll, selectTotal } =
    adapter.getSelectors(selectAdvisorState);
